module.exports = __webpack_public_path__ + "static/img/rank_166.5a3da5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_166.png
// module id = /JUR
// module chunks = 1